<template>
  <default>
    <div class="cust-travel-wrap">
      <travel-sale-page channel="customer" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import TravelSalePage from '@/components/travel/TravelSalePage';

export default {
  name: 'CustomerTravelSale',
  components: { Default, TravelSalePage },
  metaInfo: { title: 'Travel Insurance — Complete Purchase' },
};
</script>

<style src="@/assets/css/customer-travel.css"></style>
